<div class="tw-p-3" *ngIf="!isLoading && specFilter.length">
  <div class="row m-0 p-0 filter">
    <app-price-filter *ngIf="isBrowser"></app-price-filter>
    <app-eligibility-filter></app-eligibility-filter>

    <p class="tw-py-1 tw-px-0 tw-text-grayMid"><b>Brands & Models</b></p>
    <ul class="col-12 p-0" *ngIf="isPumPumPum">
      <li *ngFor="let brandFilter of brandFilterTypes | sort:'brand.name'; index as i; ">
        <ng-container *ngIf="i < 6 || showAllBrands">
          <div class="d-flex p-0 filter-type justify-content-between align-items-center">
            <div class="form-check">
              <input [checked]="isSelected(brandFilter.brand.name)" (change)="onBrandCheck(brandFilter)"
                class="form-check-input" type="checkbox" id="brand{{i}}">
              <label (click)="toggleBrandFilters(i)" class="form-check-label tw-text-grayMid" for="mobranddel{{i}}">
                {{brandFilter.brand?.name | titlecase}}
              </label>
            </div>
            <fa-icon (click)="toggleBrandFilters(i)" [icon]="brandFilter.isOpen ?  faAngleUp : faAngleDown"></fa-icon>
          </div>
          <ul [ngStyle]="{'display': brandFilter.isOpen ? 'block': 'none'}" class="tw-ml-4">
            <li *ngFor="let model of brandFilter.models; index as j;">
              <div class="form-check">
                <input (change)="onModelCheck(i, j)" class="form-check-input" type="checkbox"
                  [checked]="isSelected(model.name)" id="model{{i+''+j}}">
                <label class="form-check-label" for="model{{i+''+j}}">
                  {{model.name | titlecase}}
                </label>
              </div>
            </li>
            <hr class="tw-my-2">
          </ul>
        </ng-container>
      </li>
    </ul>
    <div class="tw-p-0 tw-text-xs tw-underline tw-text-greenMid tw-cursor-pointer"
      (click)="showAllBrands = !showAllBrands">
      Show {{showAllBrands ? 'less' : 'more'}} brands
    </div>
    <br>
    <hr>
    <ul class="col-12 p-0">
      <li *ngFor="let filter of specFilter; index as i;" class="tw-my-2">
        <div (click)="toggleFilters(i)"
          class="d-flex tw-text-grayMid p-0 filter-type justify-content-between align-items-center">
          <p class="mb-0">{{filter.label | titlecase}}</p>
          <fa-icon [icon]="filter.isOpen ? faAngleUp : faAngleDown"></fa-icon>
        </div>
        <ul [ngStyle]="{'display': filter.isOpen ? 'block': 'none'}" class="tw-mb-2">
          <li *ngFor="let item of filter.value | sort: '': filter.key === 'year'; index as j;">
            <div class="form-check tw-text-grayMid">
              <input (change)="onCheck(i, j)" class="form-check-input" type="checkbox" [checked]="isSelected(item)"
                id="filter{{i+''+j}}">
              <label class="form-check-label" for="filter{{i+''+j}}">
                {{item.toString() | titlecase}}
              </label>
            </div>
          </li>
        </ul>
        <hr>
      </li>
    </ul>
  </div>
</div>
<app-item-loader *ngIf="isLoading"></app-item-loader>